import { useParams, useLocation } from "react-router-dom";
import "./style.css"
import { useEffect, useState } from "react";
import axios from "axios";
import { Post as PostType } from "../../../types";
import ViewPost from "../../../components/Post/ViewPost";
import { useAuth } from "../../../global-components/src";
import Screen from "../../Layouts/Screen/Screen";
import NavbarTop from "../../../components/NavbarTop";
import { Helmet } from "react-helmet-async";
import Spinner, { LoadingThreeCircle } from "../../../global-components/src/components/spinner/spiner";
import { Trash } from "react-feather";
import EditPost from "../../../components/Modals/EditPost";
import { useSearchParams } from 'react-router-dom';
import RepostWithText from "../../../components/Modals/RepostWithText";
import ReportModal from "../../../components/Modals/Report";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import ModalCommentsBottom from "../../../components/Modals/comments/comments-bottom";
import ModalComments from "../../../components/Modals/comments/modal-comments";
import ModalPostLikesBottom from "../../../components/Modals/post-likes/post-likes-bottom";
import ModalPostLikes from "../../../components/Modals/post-likes/post-likes";
import { PostLoading } from "../../../components/Post/post-loading";
import { useTranslation } from 'react-i18next';

const ViewPostScreen = () => {
    const { id: postId } = useParams();
    const location = useLocation();
    const statePost = (location.state as { post?: PostType } | null)?.post ?? null;
    const [isLoadingPost, setIsLoadingPost] = useState(!statePost);
    const [post, setPost] = useState<PostType | null>(statePost);
    const { token } = useAuth();
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [searchParams] = useSearchParams();
    const showModalCommentsParam = searchParams.get('mostrarComentarios');
    const idCommentSelectedParam = searchParams.get('comentarioSelecionado');
    const [idCommentSelected, setIdCommentSelected] = useState<number | null>(null);

    useEffect(() => {
        if(showModalCommentsParam) setShowModalComments(true)
        if(idCommentSelectedParam) setIdCommentSelected(Number(idCommentSelectedParam))
            
    }, [showModalCommentsParam, idCommentSelectedParam])

    const loadPost = async (showLoading = true) => {
        const url = PACOCA_API_URL + `/posts/${postId}`;

        if (showLoading) setIsLoadingPost(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (Array.isArray(data) && data.length > 0) {
                setPost(data[0]);
            } else if (!Array.isArray(data)) {
                setPost(data);
            } else {
                if (!statePost) setPost(null);
            }
        } catch (err: any) {
            console.error("Failed to load posts:", err);
        } finally {
            if (showLoading) setIsLoadingPost(false);
        }
    };

    useEffect(() => {
        // If we already have data from router state, fetch silently in the background
        // to get fresh data (likes, comments count, etc.) without showing a spinner.
        loadPost(!statePost);
    }, [postId]);

    useEffect(() => {
        const handleModalClose = () => {
            setShow(false)
            setShowModalComments(false)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    const updatePostReportStatus = (id_post: number, wasReported: boolean) => {
        if(post){
            const newPost = post; 
            newPost.reported = wasReported
            setPost(newPost);
        }
    };

    return (
        <>
            <Helmet>
                {post ? (
                    <>
                        <title>{post ? `Paçoca - ${post?.user?.name}: ${post?.text?.slice(0, 60)}...` : "Paçoca - Publicação"}</title>
                        <meta name="description" content={post?.text?.slice(0, 160) || `Veja a publicação de ${post?.user?.name}!`} />
                        <meta name="keywords" content={`Paçoca, rede social, ${post?.user?.name}, ${post?.text?.split(' ').slice(0, 5).join(', ')}, conexões online, comunidade digital, criar perfil online, compartilhar momentos`} />
                        <meta name="author" content={post?.user?.name || 'Paçoca Inc.'} />
                        <meta property="og:title" content={`${post?.user?.name}: ${post?.text?.slice(0, 60)}... - Paçoca`} />
                        <meta property="og:description" content={`${post?.text?.slice(0, 160) || `Veja a publicação de ${post?.user?.name}!`}`} />
                        <meta property="og:image" content={`${post?.images[0]?.path ? (BUCKET_PACOCA_URL + "/" + post?.images[0].path) : '/img/pacoca-sem-braco-rounded.png'}`} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:type" content="article" />
                        <meta name="twitter:card" content="summary_large_image" />
                        <meta name="twitter:title" content={`${post?.user?.name} ${post?.text?.slice(0, 60)}... - Paçoca`} />
                        <meta name="twitter:description" content={post?.text?.slice(0, 160) || `Veja a publicação de ${post?.user?.name}!`} />
                        <meta name="twitter:image" content={`${post?.images[0]?.path ? (BUCKET_PACOCA_URL + "/" + post?.images[0].path) : '/img/pacoca-sem-braco-rounded.png'}`} />

                    </>
                ) : null}
            </Helmet>

            <Screen className="view-post-screen" paddingTopTitle title={post?.deleted_at ?  "Post apagado" : ""} withouPadding={true}>
                <div className="container-view-post">
                    {post ? (

                        <>
                            <ViewPost setPost={setPost} idCommentSelected={idCommentSelected} onOpenComments={() => setShowModalComments(true)} onOpenLikes={() => {setShow(true);}}  post={post} />
                        </>
                    ) : null}

                    <EditPost
                        onEdit={(newText, gifUrl) => {
                            // Atualizar o estado global da lista de posts
                            setPost((preData) =>
                                preData ? { ...preData, text: newText, gif_url: gifUrl ?? null } : null
                            );

                        }}
                        post={post}
                    />


                    <PostLoading loading={isLoadingPost}/>

                    {!isLoadingPost && !post ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <Trash className="icon-empty" />
                                <h3 className="w-100 text-center">Essa publicação foi apagada</h3>
                            </span>
                        </div>
                    ) : null}
                </div>

                {post ? (
                    <ReportModal onUpdateReportStatus={updatePostReportStatus} id_user={post?.user?.id} id_post={post?.id} />
                ): null}

                <RepostWithText id_post={Number(postId)} />
                {window.innerWidth <= 850 ? <ModalPostLikesBottom setOpen={setShow} open={show} idPostSelected={Number(postId)}/> : <ModalPostLikes setOpen={setShow} open={show} idPostSelected={Number(postId)}/>}
                {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={Number(postId)}/> : <ModalComments idPostSelected={Number(postId)} show={showModalComments} />}
            </Screen>
        </>
    );
};

export default ViewPostScreen;
